import { AssigneeValue, SQLGeneratedProcess } from "@avenueops/shared-types";
import SetDynamicAssigneeDropdown from "components/SetDynamicAssigneeDropdown";
import { useAssignProcessMutation } from "utils/state/processes";

interface Props {
  row: SQLGeneratedProcess;
}

export default function Assignee({ row }: Props) {
  return row.dynamicStatusId ? (
    <div
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
      className="min-w-fit"
    >
      <AssigneeDropdown row={row} />
    </div>
  ) : null;
}

function AssigneeDropdown({ row }: Props): JSX.Element {
  const { mutateAsync: assignUserMutation } = useAssignProcessMutation();
  return (
    <SetDynamicAssigneeDropdown
      assignee={
        row.assigneeId && row.assigneeEmail
          ? {
              id: row.assigneeId,
              firstName: row?.assigneeFirstName ?? null,
              lastName: row.assigneeLastName ?? null,
              email: row.assigneeEmail ?? null,
              image: row.assigneeImage ?? null,
            }
          : undefined
      }
      processId={row.id}
      mutation={(value: AssigneeValue) => assignUserMutation({ processId: row.id, assigneeInfo: value })}
      name={row.id}
      size="SMALL"
      type="BUTTON"
    />
  );
}
